<template>
  <section class="recent-post-section section-spacing">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <div class="text-center">
            <h1 class="main-heading-1-gradient">Our Recent Posts</h1>
            <p class="main-content-1">
              Stay on track and keep the overseas education trends on your
              fingertip with the latest updates from us!
            </p>
          </div>
        </div>
        <div class="col-lg-12 mt-5">
          <slick
            ref="postSlider"
            :options="postSlider"
            class="post-slider green-slick-dots arrow-slider px-lg-5"
          >
            <div v-for="(data, index) in recentPostsData" :key="index">
              <div class="post-card" @click="$router.push({ path: data.link })">
                <div class="post-img">
                  <img
                    :src="require('@/assets/imgs/posts/' + data.img)"
                    class="img-fluid"
                  />
                </div>
                <div class="post-content pt-1">
                  <h5 class="title">{{ data.title }}</h5>
                  <p class="date">{{ data.date }}</p>
                </div>
              </div>
            </div>

            <!-- <div v-for="(blog, index) in getBlogs" :key="index">
              <div
                v-if="blog.attributes.image.data"
                class="post-card"
                @click="
                  () =>
                    $router.push({
                      path: `/blogs/${blog.id}/${blog.attributes.seo_url}`,
                    })
                "
              >
                <div class="post-img">
                  <img
                    :src="`https://cms.aliff.in${blog.attributes.image.data.attributes.formats.small.url}`"
                    class="img-fluid"
                    style="width: 300px; height: 200px"
                  />
                </div>
                <div class="post-content pt-1">
                  <h5 class="title">{{ blog.attributes.heading }}</h5>
                </div>
              </div>
            </div> -->
          </slick>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "RecentPostSection",
  components: {},
  data() {
    return {
      postSlider: {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1000,
        cssEase: "ease",
        useTransform: true,
        speed: 1000,
        cssEase: "linear",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
              arrows: false,
              dots: true,
            },
          },
        ],
      },
      // postSlider: {
      //   autoplay: true,
      //   autoplaySpeed: 2500,
      //   arrows: true,
      //   dots: false,
      //   infinite: false,
      //   slidesToScroll: 1,
      //   slidesToShow: 3,
      //   responsive: [
      //     {
      //       breakpoint: 1024,
      //       settings: {
      //         slidesToShow: 2,
      //         slidesToScroll: 1,
      //       },
      //     },
      //     {
      //       breakpoint: 768,
      //       settings: {
      //         arrows: false,
      //         dots: true,
      //         slidesToShow: 1,
      //         slidesToScroll: 1,
      //       },
      //     },
      //   ],
      // },
    };
  },
  props: {
    recentPostsData: {
      type: Array,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["getBlogs"]),
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/partials/RecentPostSection.vue